import { iconButtonClasses } from '@mui/material';

export const iconButtonOverrides = {
  root: () => ({
    [`&.${iconButtonClasses.disabled}`]: {
      opacity: 0.5,
    },
  }),
};
